/* Prom Dollz — wishlist codes.
   A wishlist code (e.g. DZ-PS26713.K7-1611C0023.3F) is the wishlist written as style numbers, each with a
   2-character check so it always opens the exact dress. Nothing is stored anywhere: the code itself holds
   the list, so it never expires and works on any device. Shoppers paste it into the booking Notes;
   stylists open it at /pages/wishlist (the "Have a wishlist code?" box). */
(function () {
  'use strict';
  var PREFIX = 'DZ-', MAX = 20;
  var root = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');

  function check(id) { var n = Number(id) % 1296; return ('0' + n.toString(36)).slice(-2).toUpperCase(); }
  function enc(s) { return String(s).trim().toUpperCase().replace(/[^A-Z0-9]+/g, '_').replace(/^_+|_+$/g, ''); }
  function getJSON(url) { return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }
  function search(term) {
    return getJSON(root + '/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last')
      .then(function (j) { return (j && j.resources && j.resources.results && j.resources.results.products) || []; });
  }
  function cacheGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function cacheSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

  // One product -> one token: STYLE.CK, or @handle if the style number cannot be found by search.
  function tokenFor(handle) {
    var hit = cacheGet('pdwc:' + handle);
    if (hit) return Promise.resolve(hit);
    return getJSON(root + '/products/' + encodeURIComponent(handle) + '.js').then(function (p) {
      if (!p) return '';
      var title = String(p.title || ''), vendor = String(p.vendor || '');
      var style = title.toLowerCase().indexOf(vendor.toLowerCase()) === 0 ? title.slice(vendor.length) : title;
      var tries = [enc(style), enc(title)].filter(function (t, i, a) { return t && a.indexOf(t) === i; });
      var fallback = '@' + handle.replace(/-/g, '_');
      function attempt(i) {
        if (i >= tries.length) return fallback;
        return search(tries[i].replace(/_/g, ' ')).then(function (ps) {
          return ps.some(function (x) { return x.handle === handle; }) ? tries[i] + '.' + check(p.id) : attempt(i + 1);
        });
      }
      return Promise.resolve(attempt(0)).then(function (tok) { cacheSet('pdwc:' + handle, tok); return tok; });
    });
  }

  function build(handles) {
    var list = (handles || []).filter(function (h, i, a) { return h && a.indexOf(h) === i; }).slice(0, MAX);
    if (!list.length) return Promise.resolve('');
    return Promise.all(list.map(tokenFor)).then(function (toks) {
      toks = toks.filter(Boolean);
      return toks.length ? PREFIX + toks.join('-') : '';
    });
  }

  // Code -> { handles: [...], missing: [...] }
  function resolve(code) {
    var body = String(code || '').trim().replace(/^wishlist code:?\s*/i, '').replace(/^DZ[-\s:]*/i, '');
    var toks = body.split(/[-\s,;]+/).filter(Boolean).slice(0, MAX);
    return Promise.all(toks.map(function (tok) {
      if (tok.charAt(0) === '@') {
        var h = tok.slice(1).toLowerCase().replace(/_/g, '-');
        return getJSON(root + '/products/' + encodeURIComponent(h) + '.js').then(function (p) { return p ? [h] : null; });
      }
      var parts = tok.split('.'), term = parts[0].replace(/_/g, ' '), ck = (parts[1] || '').toUpperCase();
      return search(term).then(function (ps) {
        if (ck) { var exact = ps.filter(function (x) { return check(x.id) === ck; }); return exact.length ? [exact[0].handle] : null; }
        // typed without the check letters: every style whose name ends with this number
        var want = enc(term), ends = ps.filter(function (x) { var t = enc(x.title); return t === want || t.slice(-(want.length + 1)) === '_' + want; });
        return ends.length ? ends.map(function (x) { return x.handle; }) : (ps[0] ? [ps[0].handle] : null);
      });
    })).then(function (found) {
      var handles = [], missing = [];
      found.forEach(function (f, i) { if (f) f.forEach(function (h) { if (handles.indexOf(h) < 0) handles.push(h); }); else missing.push(toks[i].split('.')[0].replace(/^@/, '').replace(/_/g, ' ')); });
      return { handles: handles, missing: missing };
    });
  }

  window.PDWishCode = { build: build, resolve: resolve };

  /* ---------------- Wishlist page ---------------- */
  var grid = document.querySelector('[data-wish-grid]');
  if (!grid) return;
  var $ = function (s) { return document.querySelector(s); };
  var box = $('[data-wish-code]'), out = $('[data-wish-code-text]'), copyBtn = $('[data-wish-code-copy]');
  var form = $('[data-wish-lookup]'), msg = $('[data-wish-lookup-msg]');
  var params = new URLSearchParams(location.search);

  function shownHandles() {
    var shared = params.get('items');
    if (shared) return shared.split(',').filter(Boolean);
    return (window.PD && PD.wishlist && PD.wishlist.list()) || [];
  }
  function paintCode() {
    if (!box) return;
    build(shownHandles()).then(function (code) {
      box.hidden = !code;
      if (!code) return;
      out.textContent = code;
      var appt = $('[data-wish-appt]');
      if (appt) { try { var u = new URL(appt.getAttribute('href'), location.origin); u.searchParams.set('code', code); appt.setAttribute('href', u.pathname + u.search); } catch (e) {} }
    });
  }
  paintCode();
  document.addEventListener('pd:wishlist', paintCode);

  if (copyBtn) copyBtn.addEventListener('click', function () {
    var text = out.textContent;
    (navigator.clipboard ? navigator.clipboard.writeText(text) : Promise.reject())
      .then(function () { copyBtn.textContent = 'Copied'; setTimeout(function () { copyBtn.textContent = 'Copy code'; }, 2000); })
      .catch(function () { window.prompt('Copy your wishlist code:', text); });
  });

  function open(code) {
    if (/[?&]items=/.test(code)) { try { location.href = new URL(code, location.origin).pathname + new URL(code, location.origin).search; return; } catch (e) {} }
    if (msg) msg.textContent = 'Finding those dresses…';
    resolve(code).then(function (r) {
      if (!r.handles.length) { if (msg) msg.textContent = 'We couldn’t find any dresses for that code. Check it and try again.'; return; }
      var url = location.pathname + '?items=' + r.handles.map(encodeURIComponent).join(',') + (r.missing.length ? '&missing=' + encodeURIComponent(r.missing.join(', ')) : '');
      location.href = url;
    });
  }
  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    var v = (form.querySelector('input') || {}).value || '';
    if (v.trim()) open(v.trim());
  });
  if (params.get('code') && !params.get('items')) open(params.get('code'));
  if (params.get('missing') && msg) msg.textContent = 'Not found (no longer on the site): ' + params.get('missing');
})();
